import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Battery.6211cda6",
  "use": "Battery.6211cda6-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Battery.6211cda6\">\n  <path d=\"M9 4H4v2H2v2h20V6h-2V4h-5v2H9V4z\" fill=\"currentColor\" />\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 9h20v11H2V9zm9 3v2H7l6 3v-2h4l-6-3z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol